// clear state
const setStateAction = (payload) => {
    return {
        type: "SETSTATE",
        payload
    }
}

export default setStateAction;




// WEBPACK FOOTER //
// ./src/actions/setStateAction.js